var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page != null)?_c('div',{staticClass:"information_page"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.page.body)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }